/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize BloodGlucose View .
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './bloodGlucoseView';

export const mapStateToPropsBloodGlucoseView = mapStateToProps;
export const mapDispatchToPropsBloodGlucoseView = mapDispatchToProps;

export default connect(
  mapStateToPropsBloodGlucoseView,
  mapDispatchToPropsBloodGlucoseView
)(View);
